import Product from 'src/models/product';
import PaymentTerm from 'src/models/paymentTerm';

class Policy {
  constructor(data) {
    if (!data) return undefined;

    this.subContractName = data.subContractName;

    this.startDate = new Date(data.startDate);
    this.endDate = data.endDate ? new Date(data.endDate) : data.endDate;

    this.paymentTerm = new PaymentTerm(data.paymentTerm);

    this.discountAmountPaymentTerm = data.discountAmountPaymentTerm;
    this.discountPercentagePaymentTerm = data.discountPercentagePaymentTerm;
    this.totalNettoPremiumMonth = data.totalNettoPremiumMonth;
    this.totalNettoPremiumPaymentTerm = data.totalNettoPremiumPaymentTerm;
    this.totalGrossPremium = data.totalGrossPremium;
    this.totalDiscountAmount = data.totalDiscountAmount;
    this.totalCollectivityDiscountAmount = data.totalCollectivityDiscountAmount;
    this.totalAdditionalDiscountAmount = data.totalAdditionalDiscountAmount;
    this.excessDiscountAmount = data.excessDiscountAmount;
    this.excessAmount = data.excessAmount;

    this.products = data.products.map((product) => new Product(product));

    return this;
  }
}
export { Policy as default };
